<template>
  <div>
    <vue-headful
      title="Parent Onboarding - Add Child | Gradelyng"
      description="Description goes here"
    />
    <div class="onboarding-section">
      <success-modal
        v-if="show_success_modal"
        @closeTriggered="$router.push({ name: 'ParentSettingsPreferences' })"
      />

      <!-- CLOSE TRIGGER -->
      <div
        class="pageClose dialogDismiss"
        @click="$router.push({ name: 'ParentSettingsPreferences' })"
      >
        <button
          type="button"
          class="close_dialog cls_lg transparent_bg"
        ></button>
      </div>
      <!-- CLOSE TRIGGER -->

      <div class="onboarding-wrapper">
        <div class="form-container">
          <div class="font-16 font-weight-bold color_text">
            CONNECT A CHILD
          </div>

          <!-- ONBOARDING ALERT CARD -->
          <div
            class="alert-onboarding-card mt-4 d-flex align-items-center justify-content-center flex-wrap mx-auto text-center rounded-5"
          >
            <div class="icon icon-error-report brand_tonic mr-2"></div>
            Can’t find yout child?
            <router-link
              :to="{ name: 'SummerSchoolChildOnboarding' }"
              class="connect-link link-underline ml-2"
            >
              Sign up your Child</router-link
            >
          </div>

          <!-- FORM TO ADD EXISTING CHILD TO SUMMER SCHOOL -->
          <form
            action
            autocomplete="off"
            @submit.prevent="connectToSummerSchool"
          >
            <div
              class="d-flex flex-wrap flex-lg-nowrap align-items-end mb-4 justify-content-between"
            >
              <div class="form-group form-2-3 mb-0">
                <label for="StudentCode" class="control-label"
                  >Student Code
                </label>

                <input
                  type="text"
                  id="StudentCode"
                  class="form-control"
                  required
                  placeholder="XYZ/2019/2998"
                  v-model="student_code"
                />
              </div>

              <!-- VERIFICATION BUTTON, DISABLED WHEN CODE IS EMPTY -->
              <button
                type="button"
                class="btn btn-inverse verify-code"
                @click="verifyStudentCode()"
                :disabled="!student_code.length"
              >
                <span v-if="!verifying_code">VERIFY CODE</span>
                <span class="mr-2" v-if="verifying_code">VERIFYING CODE</span>
                <span
                  class="icon icon-dotted-spinner animate foont-13"
                  v-if="verifying_code"
                ></span>
              </button>
            </div>

            <div class="form-group form-2-3">
              <multi-select-2
                :selections="summer_courses"
                label="Child's courses"
                placeholder="Add new course"
                required
                @selectionUpdate="updateCourseSelection($event)"
              />
            </div>

            <div class="child-details" v-if="selected_child_info">
              <div class="avatar mr-2">
                <img
                  v-if="selected_child_info.image"
                  v-lazy="selected_child_info.image"
                  class="avatar-img"
                  alt="child"
                />
                <img
                  v-else
                  v-lazy="localImg('avatar14.png')"
                  class="avatar-img"
                  alt="child"
                />
              </div>
              <div>
                <div class="brand_primary font-weight-600 font-14">
                  {{ selected_child_info.full_name }}
                </div>
                <div class="color_grey_dark font-12 mt-1 text-uppercase">
                  {{ selected_child_info.code }}
                </div>
              </div>
            </div>

            <button
              type="submit"
              class="btn btn-accent mx-auto mt-5"
              :disabled="getButtonDisability || connecting_child"
            >
              <span v-if="!connecting_child">CONNECT</span>
              <span class="mr-2" v-if="connecting_child">CONNECTING CHILD</span>
              <span
                class="icon icon-dotted-spinner animate foont-13"
                v-if="connecting_child"
              ></span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <ResponseDialog
      v-if="alert.show"
      :alert_msg="alert.msg"
      :alert_type="alert.type"
      @closeAlert="alert.show = false"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { bgColorSetter } from "@/scripts/utilities";
import MultiSelect2 from "@/components/globalComps/MultiSelect2";
import SuccessModal from "@/components/modalComps/settingsModals/SuccessModal";

export default {
  name: "SummerSchoolOnboardingThree",

  components: {
    MultiSelect2,
    SuccessModal,
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */
        "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),

    getPayload() {
      return {
        code: this.selected_child_info.code,
        course_id: this.course_id,
      };
    },

    getButtonDisability() {
      return !this.selected_child_info || !this.course_id.length;
    },
  },

  mounted() {
    bgColorSetter("#f0f0f0");
    this.fetchSummerCourses();
  },

  data() {
    return {
      child: {},
      show_success_modal: false,
      summer_courses: [],
      selected_child_info: "",
      student_code: "",
      course_id: [],
      verifying_code: false,
      connecting_child: false,
      alert: {
        msg: "",
        type: "",
        show: false,
      },
    };
  },

  methods: {
    ...mapActions([
      "getSummerSchoolCourses",
      "searchChildCode",
      "addStudentToSummerSchoolByCode",
    ]),

    fetchSummerCourses() {
      this.getSummerSchoolCourses(1).then((response) => {
        if (response.code === 200) {
          this.summer_courses = response.data.courses;
        }
      });
    },

    verifyStudentCode() {
      this.verifying_code = true;

      this.searchChildCode(this.student_code)
        .then((response) => {
          this.verifying_code = false;

          if (response.code === 200) {
            this.selected_child_info = response.data;
            this.showDialogResponse("Code verified", "success");
          } else {
            this.selected_child_info = "";
            this.showDialogResponse("Invalid student code", "danger");
          }
        })
        .catch((err) => {
          this.verifying_code = false;
          this.selected_child_info = "";
          this.showDialogResponse("Invalid student code", "danger");
          console.log(err);
        });
    },

    showDialogResponse(msg, type) {
      this.alert = {
        msg,
        type,
        show: true,
      };
    },

    updateCourseSelection(course_id) {
      this.course_id = course_id;
    },

    connectToSummerSchool() {
      this.connecting_child = true;

      this.addStudentToSummerSchoolByCode(this.getPayload)
        .then((response) => {
          this.connecting_child = false;
          if (response.code === 200) {
            this.show_success_modal = true;
            setTimeout(
              () => this.$router.push({ name: "ParentSummerSchoolPlan" }),
              2000
            );
          } else this.showDialogResponse("Invalid Student Code", "danger");
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-section {
  height: 100vh;
}

.form-container {
  @include transform_center;
  // top: 50%;
  width: 45%;
  margin: auto;
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  @include breakpoint_max(lg) {
    width: 85%;
  }
  @include breakpoint_max(md) {
    width: 95%;
  }

  .verify-code {
    margin: 0;
    padding: 16px 32px !important;
    @include breakpoint_max(lg) {
      padding: 15px 30px !important;
    }
    @include breakpoint_max(md) {
      padding: 12px 24px !important;
    }
    @include breakpoint_max(sm) {
      margin-left: auto;
      margin-top: 15px;
    }
  }

  .form-2-3 {
    width: calc(100% - 180px);
    @include breakpoint_max(lg) {
      width: calc(100% - 175px);
    }
    @include breakpoint_max(md) {
      width: calc(100% - 180px);
    }
    @include breakpoint_max(sm) {
      width: 100%;
    }
  }

  .alert-onboarding-card {
    width: 80%;
    @include breakpoint_max(md) {
      width: 100%;
    }
  }

  .control-label {
    text-transform: none;
    font-weight: 600;
    color: $color_text;
  }
}

.child-details {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid $border-grey;
  @include flex_row_start_nowrap;
  width: 50%;

  @include breakpoint_max(lg) {
    width: 100%;
  }
  .avatar {
    width: 45px;
    height: 45px;
    border: 1.5px solid $brand_inverse;
    border-radius: 5px;
    background: $brand_inverse_light;
  }

  .avatar-img {
    width: 100%;
    height: 100%;
  }
}
</style>
